/* eslint-disable indent */
/* global initCookieConsent */

import { Dropdown } from 'bootstrap';
import Sharer from 'sharer.js';
import { setupAjaxUtils, useAjaxAutoBrowserHistoryUpdate } from './ajax-utils';
import { Fancybox } from "@fancyapps/ui";
import { it } from '@fancyapps/ui/dist/fancybox/l10n/it.esm.js';
import './carousels.init.js';
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import 'vanilla-cookieconsent';
import "vanilla-cookieconsent/dist/cookieconsent.css";
import '../scss/application.scss';

$(function () {
	// initialize ajax-utils
	setupAjaxUtils();
});


/*
 * Header handler
 */
$(document).ready(function () {
	var header = $("header");

	$(window).on("scroll", function () {
		var scrollTop = $(window).scrollTop();
		var isScrolled = scrollTop > 180;

		if ($("body").hasClass("solid-header")) {
			header.hasClass("transparent") && header.removeClass("transparent");
			header.addClass("solid");
		} else {
			if (isScrolled) {
				header.addClass("solid");
				header.addClass("header-shadow");
			} else {
				header.removeClass("header-shadow");
				header.removeClass("solid");
			}
		}
	});
});

//rise the #page-content if !$("body").hasClass("solid-header") in negative (header height)
$(function () {
	var header = $("header");
	var pageContent = $(".page-content");
	function recalculateMarginTop() {
		var headerHeight = header.outerHeight();
		if (!$("body").hasClass("solid-header") || $("body").hasClass("homepage")) {
			pageContent.css("margin-top", -headerHeight + 10);
		}
	}
	recalculateMarginTop();
	$(window).resize(function () {
		recalculateMarginTop();
	});
});


/*
* Hover effect on esperienze
*/
$(function () {
	function addHoverEffect($element) {
		var link = $element.find("a");
		link.on("mouseenter", function () {
			$(".esperienza-element:not(.no-hover)").not($element).addClass("hovered");
		}).on("mouseleave", function () {
			$(".esperienza-element:not(.no-hover)").not($element).removeClass("hovered");
		});
	}

	$("#esperienze-wrapper .esperienza-element:not(.no-hover)").each(function () {
		addHoverEffect($(this));
	});

	$("#related-articles .esperienza-element:not(.no-hover)").each(function () {
		addHoverEffect($(this));
	});
});




/*
 * Header banner margin
 */
//$(document).ready(function () {
//	var banner = $(".hd-banner");
//	setTimeout(function () {
//		if (banner.children().length > 0) {
//			banner.addClass("loaded");
//		}
//	}, 500);
//});


/* Back to top and Cookie buttons */
$(function () {
	$("#cookie-tab").fadeIn()
	$(document).on("scroll", function () {
		if ($('#back-to-top').hasClass('disabled')) return;
		$(window).scrollTop() > 200 ? $('#back-to-top').fadeIn() : $('#back-to-top').fadeOut();

		/*$(window).scrollTop() > 10 ? $("#cookie-tab").fadeIn() : $("#cookie-tab").fadeOut();*/
	});
});
/* End back to top and Cookie buttons */


/*
 *  Sharer JS visual handler
 */
$(function () {
	$(".sharer-trg").each(function () {
		var $currentElement = $(this);
		$currentElement.on("click", function (ev) {
			ev.preventDefault();
			setTimeout(function () {
				$(".social-bar").not($currentElement.find(".social-bar")).removeClass("active");
				$currentElement.find($(".social-bar")).toggleClass("active");
			}, 200);
		});
	});
});


/* 
 *  Search handler
 */
$(function () {
	const searchSection = $("#search-section");

	$(".search-trigger").each(function () {
		$(this).on("click", function (e) {
			e.preventDefault();
			searchSection.addClass("opened").fadeIn();
			if ($(window).width() < 992) {
				$(".offcanvas-header").find($(".close")).click();
			}
		});
	});

	$("#search-section-close").on("click", function (e) {
		e.preventDefault();
		searchSection.removeClass("opened").fadeOut();
	});
});


/* 
 *  Search input label animation
 */
$(document).ready(function () {
	var inputField = $("#searchInputText");
	var label = $("#search-section label");
	/*label.css("pointer-events", "none"); */

	$(window).on("beforeunload", function () {
		$("#searchInputText").val("");
	});

	inputField.on("focus", function () {
		label.addClass("active");
	});

	inputField.on("blur", function () {
		if (!inputField.val()) {
			label.removeClass("active");
		}
	});

	inputField.on("input", function () {
		if (inputField.val()) {
			label.addClass("active");
		} else {
			if (!inputField.is(":focus")) {
				label.removeClass("active");
			}
		}
	});
});



/*
 * Video handling
 */
$(document).ready(function () {
	$('.video-formazione').each(function () {
		if ($(this).find('video').length) {
			var video = $(this).find('video')[0];
			var videoTitle = $(this).find('.video-details');
			var msVideoItem = $(this);

			const removeTitle = () => {
				videoTitle.fadeOut();
				video.setAttribute("controls", "");
			}

			const showTitle = () => {
				videoTitle.fadeIn();
				video.removeAttribute("controls");
			}

			msVideoItem.on('mouseenter', function () {
				removeTitle();
			}).on('mouseleave', function () {
				showTitle();
			});

			if (video) {
				video.addEventListener('play', function () {
					videoTitle.hide();
					msVideoItem.off('mouseenter mouseleave');
				});

				video.addEventListener('pause', function () {
					msVideoItem.hover(function () {
						removeTitle();
					}, function () {
						showTitle();
					});
				});

				video.addEventListener('ended', function () {
					showTitle();
					msVideoItem.hover(function () {
						removeTitle();
					}, function () {
						showTitle();
					});
				});
			}
		}
	});
});

/* Custom accordion */
$(function () {
	$('.custom-accordion-trg').each(function () {
		var wrapper = $(this);
		var trigger = wrapper.find(".btn");
		setTimeout(function () {
			toggleAccordion(wrapper, trigger);
		}, 200);
		trigger.on("click", function (e) {
			e.preventDefault();
			toggleAccordion(wrapper, $(this));
		});
	});
});

function toggleAccordion(wrapper, trigger) {
	var accordionBody = wrapper.prev();
	if (accordionBody.hasClass("hidden-by-default")) {
		accordionBody.removeClass("hidden-by-default");
		accordionBody.fadeIn();
		trigger.text("Mostra di meno");
	} else {
		accordionBody.fadeOut();
		accordionBody.addClass("hidden-by-default");
		trigger.text("Mostra di più");
	}
}
/* END: Custom accordion */

/* Scroll arrow behavior */
$(function () {
	$('#scroll-arrow').on("click", function (e) {
		e.preventDefault();
		$(window).scrollTop($(window).height() * 0.8);
	});

	$(document).on("scroll", function () {
		$(window).scrollTop() > 300 ? $('#scroll-arrow').fadeOut() : $('#scroll-arrow').fadeIn();
	});
});
/* End scroll arrow behavior */


/*
 *  Table responsiveness
 */
$(function () {
	$(".article-body table").each(function () {
		$(this).wrap("<div class='table-responsive'></div>");
	})
})

/*
 *  Inizializzazione del fancybox 
*/
//$(function () {

//	Fancybox.bind(".gallery-trigger", {
//		groupAll: true,
//		l10n: {
//			CLOSE: "Chiudi",
//			NEXT: "Immagine successiva",
//			PREV: "Immagine precedente",
//			MODAL: "Puoi uscire dalla visualizzazione della gallery digitando ESC",
//			ERROR: "Si è verificato un errore imprevisto.",
//			IMAGE_ERROR: "Immagine non disponibile",
//			ELEMENT_NOT_FOUND: "HTML Element Not Found",
//			AJAX_NOT_FOUND: "Error Loading AJAX : Not Found",
//			AJAX_FORBIDDEN: "Error Loading AJAX : Forbidden",
//			IFRAME_ERROR: "Error Loading Page",
//			TOGGLE_FULLSCREEN: "Attiva/disattiva la modalità full-screen",
//		}
//	});

//})

/* Cookie directive */
$(function () {

	// Per "IN SOSPESO" scommentare return
	// return;

	const cookiePolicyUrl = $('body').data("cookie-policy-url");

	// obtain plugin
	var cc = initCookieConsent();

	// run plugin with your configuration
	cc.run({
		gui_options: {
			consent_modal: {
				layout: 'cloud',               // box/cloud/bar
				position: 'bottom center',     // bottom/middle/top + left/right/center
				transition: 'slide',           // zoom/slide
				swap_buttons: false            // enable to invert buttons
			},
			settings_modal: {
				layout: 'box',                 // box/bar
				// position: 'left',           // left/right
				transition: 'slide'            // zoom/slide
			}
		},
		current_lang: 'it',
		page_scripts: true,                        // default: false
		delay: 1500,                               // default: 0
		cookie_name: 'cookie_consent',             // default: 'cc_cookie'

		//autoclear_cookies: true,                 // default: false
		// mode: 'opt-in'                          // default: 'opt-in'; value: 'opt-in' or 'opt-out'
		// auto_language: '',                      // default: null; could also be 'browser' or 'document'
		// autorun: true,                          // default: true
		// force_consent: false,                   // default: false
		// hide_from_bots: false,                  // default: false
		// remove_cookie_tables: false             // default: false

		// cookie_expiration: 182,                 // default: 182 (days)
		// cookie_necessary_only_expiration: 182   // default: disabled
		// cookie_domain: location.hostname,       // default: current domain
		// cookie_path: '/',                       // default: root
		// cookie_same_site: 'Lax',                // default: 'Lax'
		// use_rfc_cookie: false,                  // default: false
		// revision: 0,                            // default: 0

		onFirstAction: function (user_preferences, cookie) {
			if (user_preferences.accepted_categories.indexOf("third_part") != -1) {
				location.reload();
			}
			//console.log('User accept type:', user_preferences.accept_type);
			//console.log('User accepted these categories', user_preferences.accepted_categories)
			//console.log('User reject these categories:', user_preferences.rejected_categories);
		},

		onAccept: function (cookie) {
			//console.log(cookie);
			// callback triggered on the first accept/reject action, and after each page load
		},

		onChange: function (cookie, changed_categories) {
			if (changed_categories.indexOf("third_part") != -1) {
				location.reload();
			}
		},

		languages: {
			'it': {
				consent_modal: {
					position: 'bottom center',
					title: 'Cookie policy',
					description: 'Questo sito utilizza i cookie per garantire il suo corretto funzionamento e una migliore esperienza di navigazione. Tutti i cookie, tranne quelli strettamente necessari al funzionamento del sito, richiedono un consenso esplicito da parte tua. <button type="button" data-cc="c-settings" class="cc-link">Visualizza le preferenze</button>',
					primary_btn: {
						text: 'Accetta tutti',
						role: 'accept_all'              // 'accept_selected' or 'accept_all'
					},
					secondary_btn: {
						text: 'Rifiuta tutti',
						role: 'accept_necessary'        // 'settings' or 'accept_necessary'
					}
				},
				settings_modal: {
					title: 'Preferenze sui cookie',
					save_settings_btn: 'Salva',
					accept_all_btn: 'Accetta tutti',
					reject_all_btn: 'Rifiuta tutti',
					close_btn_label: 'Chiudi',
					cookie_table_headers: [
						{ col1: 'Nome' },
						{ col2: 'Dominio' },
						{ col3: 'Durata' },
						{ col4: 'Descrizione' }
					],
					blocks: [
						{
							title: 'Uso dei cookie',
							description: 'Questo sito utilizza cookie essenziali per garantire il suo corretto funzionamento, cookie di terze parti per fornirti una migliore esperienza di navigazione e cookie di tracciamento per capire come interagisci con esso. I cookie di tracciamento e di terze parti verranno impostati solo dopo il tuo consenso.'
						}, {
							title: 'Cookie tecnici strettamente necessari per la navigazione',
							description: 'Questi cookie sono essenziali per il corretto funzionamento del sito web. Senza questi cookie la navigazione sarebbe impossibile.',
							toggle: {
								value: 'necessary',
								enabled: true,
								readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
							},
							cookie_table: [             // list of all expected cookies
								{
									col1: 'ASP.NET_SessionId',
									col2: location.host,
									col3: 'Scade con la sessione di navigazione',
									col4: 'Memorizza la sessione di navigazione corrente'
								},
								{
									col1: 'cookie_consent',
									col2: location.host,
									col3: '6 mesi',
									col4: 'Memorizza le preferenze sui cookie da te impostate'
								},
								{
									col1: 'Infocookie, cookieok',
									col2: location.host,
									col3: 'Nessuna scadenza',
									col4: 'Saranno utilizzati per memorizzare l\'avvenuta presentazione dell\'informativa sui cookie all\'utente'
								},
								{
									col1: 'nfocookie, cookieok',
									col2: location.host,
									col3: '12 mesi',
									col4: 'Evita che l’informativa breve contenuta nel banner ricompaia nel caso di collegamenti effettuati entro il termine di scadenza. Si attiva cliccando il tasto “OK” sul banner o proseguendo la navigazione tramite scroll'
								}
							]
						},
						{
							title: 'Cookie analitici',
							description: 'Questi cookie raccolgono informazioni su come utilizzi il sito web, quali pagine hai visitato e quali link hai cliccato. Tutti i dati sono resi anonimi e non possono essere utilizzati per identificarti.',
							toggle: {
								value: 'unnecessary',     // your cookie category
								enabled: false,
								readonly: false
							},
							cookie_table: [             // list of all expected cookies
								{
									col1: '_ga',
									col2: 'google.com',
									col3: '12 Mesi',
									col4: 'Registra un ID univoco utilizzato per generare dati statistici su come il visitatore utilizza il sito internet.'
								},
								{
									col1: '_gat',
									col2: 'google.com',
									col3: '1 Giorno',
									col4: 'Utilizzato da Google Analytics per limitare la frequenza delle richieste'
								},
								{
									col1: '_gid',
									col2: 'google.com',
									col3: '1 Giorno',
									col4: 'Registra un ID univoco utilizzato per generare dati statistici su come il visitatore utilizza il sito internet.'
								},
								{
									col1: '__utma, __utma, __utmb, __utmc, __utmt, __utmv, __utmz',
									col2: 'google.com',
									col3: 'Nessuna scadenza',
									col4: 'Utilizzati da Google analytics per raccogliere informazioni statistiche sulle visite al sito in forma aggregata e anonima'
								}
							]
						},
						{
							title: 'Cookie di terze parti ',
							description: 'Questi cookie ci permettono di arricchire l\'esperienza di navigazione con contenuti multimediali provenienti da altre piattaforme.\nPossono essere cookie legati all’embed di contenuti presenti sui social di maggiore diffusione',
							toggle: {
								value: 'third_part',     // your cookie category
								enabled: false,
								readonly: false
							},
							cookie_table: [             // list of all expected cookies
								{
									col1: 'CONSENT',
									col2: 'www.youtube-nocookie.com',
									col3: 'Scade con la sessione di navigazione',
									col4: 'Dopo che l\'utente ha dato il proprio consenso, il cookie CONSENT salva l\'autorizzazione dell\'utente a inoltrare i dati a YouTube'
								},
								{
									col1: 'CONSENT',
									col2: 'google.com',
									col3: 'Nessuna scadenza',
									col4: 'Dopo che l\'utente ha dato il proprio consenso, il cookie CONSENT salva l\'autorizzazione dell\'utente a inoltrare i dati a GoogleMaps'
								}
							]
						},
						{
							title: 'Maggiori informazioni',
							description: `Per maggiori informazioni sulla nostra cookie policy <a class="cc-link" href="${cookiePolicyUrl}">visita la pagina ad essa dedicata</a>`
						}
					]
				}
			}
		}
	});

	//console.log(cc.get('level'))

	if (cc.get('level') && $(window).scrollTop() > 150) {
		$("#cookie-tab").fadeIn(400);
	}


	setTimeout(function () {
		var bodyCss = 'body{display:flex;align-items:center;justify-content:center; border: dotted 3px #344952; max-height: calc(100% - 6px); padding-inline: 10px;}';
		var imgCss = 'img{max-width:100%;max-height:90%;margin-inline:auto}';
		var style = document.createElement("style");
		style.appendChild(document.createTextNode(imgCss));
		style.appendChild(document.createTextNode(bodyCss));
		$("iframe").each(function () {
			if (!this.contentDocument) return;
			this.contentDocument.head.appendChild(style);
		})
	}, 100);
})
/* Cookie directive - END */

/* 
	Fancybox sugli elementi con data-multimediaobject valorizzato
*/
$(function () {
	$(document).on('click', '[data-multimediaobject]', function (ev) {
		//$('[data-multimediaobject]').on('click', function (ev) {
		ev.preventDefault();
		var $this = $(this);
		var multimedia = $this.data('multimediaobject');
		var isThereAnymultimediaContent = $.grep(multimedia, function (el) {
			return (el['media-type'] == 'audio' || el['media-type'] == 'video');
		}).length;
		var buttons = ['fullScreen', 'share', 'close'];
		if (!isThereAnymultimediaContent) buttons.splice(2, 0, 'thumbs');

		var fancy = new Fancybox(multimedia,
			{
				Thumbs: {
					type: "classic"
				},
				iframe: {
					preload: false
				},
				groupAll: true,
				afterShow: function (instance, slide) {
					slide.$content.find('iframe').delay(500).animate({
						opacity: 1
					});
				},
				thumbs: {
					autoStart: (!isThereAnymultimediaContent) // && !isMobile()
				},
				buttons: buttons,
				hash: $this.data('hash'),
				lang: "it",
				loop: false,
				i18n: it
			}
		);
	})
})


